<template>
    <div data-tf-live="01J069NQNTQ2685AJWMQTYTHHK"></div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from "pinia";

import { useJobSearchPlanStore } from "../store/job-search-plan.store";

const jobSearchPlanStore = useJobSearchPlanStore();
const { isSidebarVisible } = storeToRefs(jobSearchPlanStore);

import { useCommunityStore } from "../store/community.store";
import { useFeedbackButtonVisible } from "../composables/feedbackButton.composable";

const communityStore = useCommunityStore();
const { showDocumentPreview } = storeToRefs(communityStore);

const route = useRoute();
const router = useRouter();

const {
    FEEDBACK_BUTTON_CLASS,
    GIUDE_BUTTON_ID,
    isGiudeFormMounted,
    isTypeFormMounted,

    showFeedbackButton,
    hideFeedbackButton,
    isButtonHiddenForRoute,
    hideGuideBtn,
    showGuideBtn,
    initiateGiudeBtn,
    initiateTypeformBtn,
} = useFeedbackButtonVisible();

const removeJS = (filename) => {
    const tags = document.getElementsByTagName("script");

    for (let i = tags.length; i >= 0; i--) {
        if (tags[i] && tags[i].getAttribute("src") != null && tags[i].getAttribute("src").indexOf(filename) !== -1) {
            tags[i].parentNode.removeChild(tags[i]);
        }
    }
};

const routeChangeHandler = (newRoute) => {
    if (!isTypeFormMounted.value) return;

    if (isButtonHiddenForRoute(newRoute.name)) {
        hideFeedbackButton();
        hideGuideBtn();
    } else {
        showFeedbackButton();
        showGuideBtn();
    }

    if(route.name === "home" && isSidebarVisible?.value) {
        hideFeedbackButton();
        hideGuideBtn();
    }
};

const sideBarChangeHandler = (newValue) => {
    if (newValue) {
        hideFeedbackButton();
        hideGuideBtn();
    } else {
        showFeedbackButton();
        showGuideBtn();
    }
};

const communityPreviewOpenHandler = (newValue) => {
    if (newValue) {
        hideFeedbackButton();
		hideGuideBtn();
    } else {
        showFeedbackButton();
		showGuideBtn()
    }
};

watch(route, routeChangeHandler);
watch(showDocumentPreview, communityPreviewOpenHandler);
watch(isSidebarVisible, sideBarChangeHandler);

onUnmounted(() => {
    if (document.querySelectorAll(FEEDBACK_BUTTON_CLASS)?.length) {
        document.querySelectorAll(FEEDBACK_BUTTON_CLASS)[0].remove();
    }

    if (document.querySelectorAll(GIUDE_BUTTON_ID)?.length) {
        document.querySelectorAll(GIUDE_BUTTON_ID)[0].remove();
    }

    removeJS("//embed.typeform.com/next/embed.js");
    removeJS("https://desk.zoho.com/portal/api/web/inapp/729283000034838223?orgId=778046850");

});

onMounted(async () => {
    await router.isReady();

    if (!isGiudeFormMounted.value && !isSidebarVisible?.value) {
        initiateGiudeBtn();
    }

    if (!isTypeFormMounted.value && !isButtonHiddenForRoute(route.name) && !isSidebarVisible?.value) {
        initiateTypeformBtn();
    }
});
</script>
